
import DemandList from '../components/demand-list.vue';

export default {
  name: 'ReadonlyDemandList',

  components: {
    DemandList: DemandList
  }
};